var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "AppCard",
    [
      _c(
        "v-card-title",
        { staticClass: "headline justify-center font-weight-bold" },
        [_vm._v("\n    Upload statistics\n  ")]
      ),
      _vm._v(" "),
      _c("v-card-subtitle", { staticClass: "text-center" }, [
        _vm._v("\n    Files uploaded to this trial within the last week.\n  ")
      ]),
      _vm._v(" "),
      _c(
        "v-card-text",
        [
          _c("GChart", {
            staticClass: "primary--text",
            attrs: {
              type: "LineChart",
              data: _vm.chartData,
              options: _vm.chartOptions
            }
          }),
          _vm._v(" "),
          _c(
            "v-dialog",
            {
              attrs: {
                transition: "dialog-top-transition",
                "max-width": 600,
                "max-height": 900
              },
              model: {
                value: _vm.showDatePicker,
                callback: function($$v) {
                  _vm.showDatePicker = $$v
                },
                expression: "showDatePicker"
              }
            },
            [
              _c("v-date-picker", {
                attrs: { range: "" },
                model: {
                  value: _vm.dates,
                  callback: function($$v) {
                    _vm.dates = $$v
                  },
                  expression: "dates"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: { label: "Date range", text: "" },
              on: {
                click: function($event) {
                  _vm.showDatePicker = true
                }
              }
            },
            [
              _c(
                "v-icon",
                { staticClass: "primary--text", attrs: { left: "" } },
                [_vm._v(" mdi-calendar ")]
              ),
              _vm._v("\n      " + _vm._s(_vm.dateRangeText) + "\n    ")
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }